// import React from "react";
// import {
//   Chart as ChartJS,
//   CategoryScale,
//   LinearScale,
//   PointElement,
//   LineElement,
//   Title,
//   Tooltip,
//   Legend,
// } from "chart.js";
// import { Line } from "react-chartjs-2";

// 

// function LiveStreamAnalytics() {
//   const datas = [
//     {
//       user: "Admissssn",
//       mail: "admin@admin.com",
//       live: "Zootopia",
//       amount: "$",
//       date: "02 Jul 2021",
//     },
//     {
//       user: "Admin",
//       mail: "admin@admin.com",
//       live: "Zootopia",
//       amount: "$",
//       date: "02 Jul 2021",
//     },
//   ];

//   const options = {
//     type: "line",
//     responsive: true,
//     plugins: {
//       legend: {
//         position: "top",
//       },
//     },
//   };

//   const labels = [
//     "July",
//     "December",
//     "December",
//     "April",
//     "May",
//     "May",
//     "May",
//     "May",
//     "May",
//     "May",
//     "May",
//   ];

//   const data = {
//     labels,
//     datasets: [
//       {
//         label: "Purchased Videos",

//         data: [1.0, 1.0, 1.0, 1.0, 1.0, 1.0, 1.0, 1.0, 1.0, 1.0, 1.0, 0.0, 2.0],
//         borderColor: "rgb(53, 162, 235)",
//         lineTension: 0.4,
//       },
//     ],
//   };

//   return (
//     <>
//       <div className=" m-0 p-0">
//         <div className="">
//           <section className="section container-fluid pt-3">
//             <div id="content-page" className="content-page">
//               <div className="iq-card">
//                 <div className="col-md-12">
//                   <div className="iq-card-header  justify-content-between">
//                     <div className="iq-header-title">
//                       <h4 className="card-title">Purchased Live Analyticssss :</h4>
//                     </div>
//                   </div>

//                   <div className="row p-3">
//                     <hr />
//                     <div className="col-md-12">
//                       <div className="row mt-3">
//                         <div className="col-md-3">
//                           <label for="start_time"> Start Date: </label>
//                           <input
//                             type="date"
//                             className="form-control"
//                             id="start_time"
//                             name="start_time"
//                           />
//                         </div>
//                         <div className="col-md-3">
//                           <label for="start_time"> End Date: </label>
//                           <input
//                             type="date"
//                             className="form-control"
//                             id="end_time"
//                             name="end_time"
//                           />
//                         </div>

//                         <div className="col-md-3 d-flex align-items-end">
//                           <div className="dropdown">
//                             <button
//                               className="btn btn-outline-dark filter-btn dropdown-toggle"
//                               type="button"
//                               data-bs-toggle="dropdown"
//                               aria-expanded="false"
//                             >
//                               Filter
//                             </button>
//                             <ul className="dropdown-menu">
//                               <li>
//                                 <a className="dropdown-item" href="#">
//                                   1 Day
//                                 </a>
//                               </li>
//                               <li>
//                                 <a className="dropdown-item" href="#">
//                                   1 Week
//                                 </a>
//                               </li>
//                               <li>
//                                 <a className="dropdown-item" href="#">
//                                   1 Month{" "}
//                                 </a>
//                               </li>
//                             </ul>
//                           </div>
//                         </div>

//                         <div className="col-md-3 d-flex align-items-end">
//                           <span
//                             id="export"
//                             className="btn btn-primary download-btn btn-sm"
//                           >
//                             Download CSV
//                           </span>
//                         </div>
//                       </div>
//                       <div className="clear"></div>

//                       <div className="mt-5">
//                         <h4>Purchased Live Graph :</h4>
//                       </div>
//                       <div>
//                         <div className="row mt-5">
//                           <div className="col-md-2"></div>
//                           <div className="col-md-7">
//                             <Line options={options} data={data} />
//                             <p className="text-center">Purchased Videos </p>
//                           </div>
//                           <div className="col-md-3"></div>
//                         </div>
//                       </div>

//                       <div className="d-flex justify-content-between p-3">
//                         <div className="d-flex">
//                           <p>Show 10</p>
//                           <p>&nbsp; &nbsp; entries</p>
//                         </div>
//                         <div className="d-flex">
//                           <p>Search:</p>
//                           <input
//                             type="search"
//                             id="gsearch"
//                             name="gsearch"
//                             className="border-0 search-rev"
//                           />
//                         </div>
//                       </div>

//                       <div className="row">
//                         <div className="col-md-12">
//                           <table className="table" id="user_tabledss">
//                             <thead>
//                               <tr className="r1">
//                                 <th>#</th>
//                                 <th>User Name</th>
//                                 <th>User Email</th>
//                                 <th>Live Name</th>
//                                 <th>Amount </th>
//                                 <th>Purchased Date</th>
//                               </tr>
//                             </thead>
//                             {datas.map((item, key) => (
//                               <thead>
//                                 <tr  key={item?.id} className="r1">
//                                   <td key={key}> {key + 1} </td>
//                                   <td>{item.user}</td>
//                                   <td>{item.mail}</td>
//                                   <td>{item.live}</td>
//                                   <td>{item.amount} </td>
//                                   <td>{item.date}</td>
//                                 </tr>
//                               </thead>
//                             ))}
//                             <tbody></tbody>
//                           </table>
//                         </div>
//                         <div className="col-md-4"></div>
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//                 <div></div>
//               </div>
//             </div>
//           </section>
//         </div>
//       </div>
//     </>
//   );
// }

// export default LiveStreamAnalytics;


import React, { useState, useEffect } from "react";
import { Line } from "react-chartjs-2";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory, {
  PaginationProvider,
} from "react-bootstrap-table2-paginator";
import {
  MdKeyboardDoubleArrowLeft,
  MdKeyboardDoubleArrowRight,
} from "react-icons/md";
import './LiveStreamAnalytics.css'
import Response_Loading_processing from "../../../../src/layout/Others/Response_Loading_processing";

const LiveStreamAnalytics = () => {

  const [datas, setDatas] = useState([]);
  const [userCount, setUserCount] = useState(0);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [filter, setFilter] = useState("");
  const [loading, setLoading] = useState(false);
  const [filteredData, setFilteredData] = useState([]);
  const [selectAll, setSelectAll] = useState(false);
  const [selectedModerator, setSelectedModerator] = useState("");

  const [filtermoderator, setFiltermoderator] = useState([

    {
      'name': 'Registered Users',
      'value': 'registered'
    },
    {
      'name': 'Subscriber',
      'value': 'subscriber'
    },
    {
      'name': 'Admin',
      'value': 'admin'
    },
    {
      'name': 'PPV Users',
      'value': 'ppv_users'
    },
  ]);
  const fetchData = async () => {
    try {
      setLoading(true);

      // Replace the following URL with your actual GET API endpoint
      const response = await fetch(
        `https://api.example.com/users?start_date=${startDate}&end_date=${endDate}`,
        {
          method: "GET",
          headers: {
            // Add headers if necessary
          },
        }
      );

      const data = await response.json();
      setDatas(data);
      setUserCount(data.length); // Update this based on your data structure

      // Filter data based on selected moderator
      const filtered = selectedModerator ? data.filter(item => item?.role === selectedModerator) : data;
      setFilteredData(filtered);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(async () => {
    fetchData();
  }, [startDate, endDate, selectedModerator]);

  const handleExport = async () => {
    try {
      // Replace the following URL with your actual POST API endpoint for exporting data
      const exportResponse = await fetch("https://api.example.com/export", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          startDate,
          endDate,
          selectedData: filteredData,
        }),
      });

      if (exportResponse.ok) {
        const blob = await exportResponse.blob();

        // Create a link element and trigger the download
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = "exported_data.xlsx";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      } else {
        console.error("Export failed:", exportResponse.statusText);
      }
    } catch (error) {
      console.error("Error exporting data:", error);
    }
  };

  // const newLabel = ["May", "June", "July", "August", "September", "October"]; // Example labels
  // const newData = [15, 25, 35, 30, 45]; // Example count values

  // const newRandomColors = newData.map(() => {
  //   return `rgba(${Math.floor(Math.random() * 256)}, ${Math.floor(
  //     Math.random() * 256
  //   )}, ${Math.floor(Math.random() * 256)}, 0.7)`;
  // });

  // const newChartData = {
  //   labels: newLabel,
  //   datasets: [
  //     {
  //       data: newData,
  //       borderColor: newRandomColors,
  //       backgroundColor: newRandomColors,
  //       borderWidth: 1,
  //       pointStyle: 'circle', // Use circles as points
  //       pointRadius: 5, // Adjust the size of the circles
  //       tension: 0.2 // Adjust the tension of the line
  //     }
  //   ]
  // };

  // const newOptionsData = {  // Define new optionsdata for the new chart
  //   type: "line",
  //   responsive: true,
  //   plugins: {
  //     legend: {
  //       display: false // Hide legend for better appearance
  //     }
  //   },
  //   scales: {
  //     x: {
  //       grid: {
  //         display: false // Hide x-axis gridlines
  //       }
  //     },
  //     y: {
  //       beginAtZero: true // Start y-axis scale at 0
  //     }
  //   }
  // };


  const newOptionsData = {
    type: "line",
    responsive: true,
    plugins: {
      legend: {
        position: "bottom",
      },
    },
  };

  const labels = [
    "July",
    "December",
    "December",
    "April",
    "May",
    "May",
    "May",
    "May",
    "May",
    "May",
    "May",
  ];

  const newChartData = {
    labels,
    datasets: [
      {
        label: "Purchased Live",
        data: [1.0, 1.0, 1.0, 3.5, 1.0, 0, 1.0, 1.0, 1.0, 5.0, 1.0, 0.0, 2.0],
        borderColor: "rgb(255, 99, 132)",
        backgroundColor: "rgba(255, 99, 132, 0.2)",
        borderWidth: 2,
        lineTension: 0.4,
      },
    ],
  };

  const columns = [
    {
      dataField: "s_no",
      text: "S.NO",
    },
    {
      dataField: "video_name",
      text: "VIDEO NAME",
    },
    {
      dataField: "user_email",
      text: "USER EMAIL",
    },
    {
      dataField: "live_name",
      text: "LIVE NAME",
    },
    {
      dataField: "amount",
      text: "AMOUNT",
    },
    {
      dataField: "purchased_date",
      text: "PURCHASED DATE",
    },
  ];

  const options = {
    page: 1,
    sizePerPage: 10,
    nextPageText: "Next",
    prePageText: "Prev",
    firstPageText: <MdKeyboardDoubleArrowLeft />,
    lastPageText: <MdKeyboardDoubleArrowRight />,
    showTotal: true,
    alwaysShowAllBtns: true,
    sizePerPageList: [
      { text: "5", value: 5 },
      { text: "10", value: 10 },
      { text: "All", value: Number(filteredData?.length) },
    ],
  };

  return (
    <div className="m-0 p-0">
      <section className="section container-fluid pt-3">
        <div id="content-page" className="content-page">
          <div className="iq-card-header justify-content-between">
            <div className="iq-header-title p-0">
              <h4 className="card-title">Purchased Live Analytics</h4>
            </div>
          </div>
          <div className="iq-card mt-3">
            <div className="row p-3">
              <div className="col-md-12">
                <div className="row mt-2 align-items-center">
                  <div className="col-md-12 another-live-analytics">
                    <Line options={newOptionsData} data={newChartData} />
                    {/* <p className="text-center">Purchased Live Count</p> */}
                  </div>
                </div>

                <div className="col-lg-12">
                  <div className="mt-3">
                    <div className="row align-items-center">
                      <div className="col-lg-4 col-md-4 col-sm-4 col-4">
                        <label htmlFor="start_time"> Start Date: </label>
                        <input
                          type="date"
                          className="rs-input form-control-lg"
                          id="start_time"
                          name="start_time"
                          value={startDate}
                          onChange={(e) => setStartDate(e.target.value)}
                        />
                      </div>
                      <div className="col-lg-4 col-md-4 col-sm-4 col-4">
                        <label htmlFor="end_time"> End Date: </label>
                        <input
                          type="date"
                          className="rs-input form-control-lg"
                          id="end_time"
                          name="end_time"
                          value={endDate}
                          onChange={(e) => setEndDate(e.target.value)}
                        />
                      </div>

                      <div className="col-lg-4 col-md-4 col-sm-4 col-4 text-right">
                        <span
                          id="export"
                          className="btn btn-success w-50"
                          onClick={handleExport}
                        >
                          Export
                        </span>
                      </div>
                    </div>

                    <div className="d-flex mt-3 justify-content-between align-items-center flex-wrap mb-3 gap-3">
                      <div className="row col-lg-12 align-items-center">
                        <div className="col-lg-6 align-items-center">

                          <input
                            type="text"
                            placeholder="Filter all.."
                            className="filter form-control "
                            value={filter}
                            onChange={(e) => setFilter(e.target.value)}
                          />

                          {filter?.length > 0 && (
                            <button
                              type="button"
                              className="closeBtn"
                              onClick={() => setFilter("")}
                            >
                              <i className="fa fa-times"></i>
                            </button>
                          )}

                        </div>
                        <div className="col-lg-6  ">

                          <div className="row align-items-center">
                            <h5>Filter Moderator</h5>
                            <div className="col-md-12">
                              <select className="form-select" id="role" name="role"
                                onChange={(e) => setSelectedModerator(e.target.value)}
                                value={selectedModerator}>
                                <option value="0">Choose an Moderator</option>

                                {filtermoderator?.map((item, key) => (
                                  <option key={key} value={item?.value}>{item?.name}</option>
                                ))}
                              </select>
                            </div>
                          </div>

                        </div>
                      </div>

                      {/* <div className="filterContainer">


                        {filter?.length > 0 && (
                          <button
                            type="button"
                            className="closeBtn"
                            onClick={() => setFilter("")}
                          >
                            <i className="fa fa-times"></i>
                          </button>
                        )}
                      </div> */}
                      <PaginationProvider
                        pagination={paginationFactory(options)}
                      >
                        {({ paginationTableProps }) => (
                          <div className="bootstrapTable p-2">
                            <BootstrapTable
                              keyField="id"
                              columns={columns}
                              data={filteredData}
                              className="no-border-table"
                              noDataIndication={
                                <div className="noRecord">
                                  {loading ? (
                                    <label>
                                      <Response_Loading_processing></Response_Loading_processing>
                                      Loading...
                                    </label>
                                  ) : (
                                    filteredData?.length <= 0 && (
                                      <p>No Record Found!</p>
                                    )
                                  )}
                                </div>
                              }
                              hover
                              headerClasses="videoWidth"
                              selectAll={selectAll}
                              {...paginationTableProps}
                            />
                          </div>
                        )}
                      </PaginationProvider>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default LiveStreamAnalytics;

